/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Landing_Subscribedescription1Inputs */

const en_welcome_landing_subscribedescription1 = /** @type {(inputs: Welcome_Landing_Subscribedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request, complete, and manage the subscription digitally`)
};

/**
* | output |
* | --- |
* | "Request, complete, and manage the subscription digitally" |
*
* @param {Welcome_Landing_Subscribedescription1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const welcome_landing_subscribedescription1 = /** @type {((inputs?: Welcome_Landing_Subscribedescription1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Landing_Subscribedescription1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_landing_subscribedescription1(inputs)
});
export { welcome_landing_subscribedescription1 as "welcome_landing_subscribeDescription" }